import { Component, Input } from '@angular/core';

import { OrderItemUI } from '@azavista/payments';
import { getOrderItemTrackByValue } from '../utils';

@Component({
    selector: 'aza-rws-shopping-cart-v2-order-items-card-view',
    templateUrl: 'shopping-cart-v2-order-items-card-view.component.html',
    standalone: false
})
export class ShoppingCartV2OrderItemsCardViewComponent {
    @Input() orderItems: OrderItemUI[];
    @Input() orderTotal: number;
    @Input() cartCurrency: string;

    getOrderItemTrackByValue = getOrderItemTrackByValue;
}
